<template>
  <div class="settings-instruction">
    <h2 class="headline">Voucher Page page settings</h2>
    <v-form v-if="isLoader" class="form">
      <v-card class="input">
        <content-editor
          label="Title"
          class="z-index10"
          v-model="formData.title"
          @input="$v.formData.title.$touch"
          @blur="$v.formData.title.$touch"
          :error="$v.formData.title"
        />
      </v-card>

      <v-card width="320">
        <div class="grey lighten-2">
          <v-card-media height="130" :src="formData.imageUrl"/>
        </div>

        <v-card-title><h3>Set Top Image</h3></v-card-title>
        <v-card-actions>
          <v-btn
            flat
            color="success"
            @click.native="openGallery">Choose</v-btn>
          <v-btn
            flat
            color="error"
            :disabled="!formData.imageUrl"
            @click="resetImage()">Reset
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card>
        <content-editor
          label="Barcode Description"
          class="z-index5"
          v-model="formData.barcodeDescription"
          @input="$v.formData.barcodeDescription.$touch"
          @blur="$v.formData.barcodeDescription.$touch"
          :error="$v.formData.barcodeDescription"
        />
      </v-card>
      <v-card-title>
        <span class="headline"> Display Fields </span>
      </v-card-title>
      <v-layout class="mx-3">
        <v-checkbox
          label="Full Name"
          v-model="displayFields"
          value="FullName"
        />
        <v-checkbox
          label="Company"
          v-model="displayFields"
          value="Company"
        />
        <v-checkbox
          label="Email"
          v-model="displayFields"
          value="Email"
        />
        <v-checkbox
          label="Country"
          v-model="displayFields"
          value="Country"
        />
        <v-checkbox
          label="Job Title"
          v-model="displayFields"
          value="JobTitle"
        />
      </v-layout>
      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="$v.$invalid || !isWriteAvailable"
      >
        Update form
      </v-btn>
    </v-form>
    <v-dialog v-model="isGalleryVisible">
      <galleries-list :modalView="true" @pickedImage="selectImage"/>
    </v-dialog>
  </div>
</template>

<script>
  import EImageUploader from '@/components/shared/EImageUploader'
  import { mapGetters, mapActions } from 'vuex'
  import { path, pathOr, clone } from 'ramda'
  import { required } from 'vuelidate/lib/validators'
  import GalleriesList from '@/components/pages/Gallery/GalleriesList'
  import mixins from '@/utils/mixins'

  export default {
    name: 'VoucherPage',
    components: { EImageUploader, GalleriesList },
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        isGalleryVisible: false,
        formData: {},
        displayFields: [],
        isLoader: false,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'general_settings:write'
      }
    },
    validations: {
      formData: {
        title: { required },
        imageUrl: { required },
        barcodeDescription: { required }
      }
    },
    computed: {
      ...mapGetters(['getSettings']),
      voucherPageSettings () {
        return path(['vaucherPageSetting'], this.getSettings)
      }
    },
    methods: {
      ...mapActions([
        'changeVoucherPage',
        'fetchGeneralSettings'
      ]),
      selectImage (val) {
        this.formData.imageUrl = val.imagesUrls.originalImageUrl
        this.isGalleryVisible = false
      },
      openGallery () {
        this.isGalleryVisible = true
      },
      resetBanner () {
        this.formData.imageUrl = ''
      },
      async submitForm () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        await this.changeVoucherPage({ ...this.formData, displayFields: this.displayFields })
        await this.fetchGeneralSettings()
        this.formData = clone(this.voucherPageSettings)
      }
    },
    async created () {
      if (!this.getSettings) {
        await this.fetchGeneralSettings()
      }
      this.formData = clone(this.voucherPageSettings)
      this.displayFields = pathOr([], ['displayFields'], this.voucherPageSettings)
      this.isLoader = true
    }
  }
</script>

<style lang="scss" scoped>
  .input,
  .headline {
    max-width: 480px;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .headline {
    margin-bottom: 20px;
    text-align: center;
  }

  .card {
    padding: 10px;
    margin-bottom: 15px;
  }

  .z-index10 {
    z-index: 10;
    position: relative;
  }

  .z-index5 {
    z-index: 5;
    position: relative;
  }

  .btn {
    &_submit {
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/StaticPages/VoucherPage.vue